import * as ActionTypes from './ImageEditorFirmsActionTypes';
import { IImageEditorFirm } from '../Entities';
import ImageEditorFirmsApi from '../api/ImageEditorFirmsApi';

function getImageEditorFirmsSuccess(imageEditorFirms: IImageEditorFirm[]) {
    return {
        type: ActionTypes.GET_IMAGE_EDITOR_FIRMS_SUCCESS,
        result: imageEditorFirms
    };
}

export function getImageEditorFirms() {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        ImageEditorFirmsApi.getImageEditorFirms().then((result: IImageEditorFirm[]) => {
            dispatch(getImageEditorFirmsSuccess(result));
        });
}

function saveImageEditorFirmSuccess(imageEditorFirm: IImageEditorFirm) {
    return {
        type: ActionTypes.SAVE_IMAGE_EDITOR_FIRM_SUCCESS,
        result: imageEditorFirm
    };
}

export function addImageEditorFirm(imageEditorFirm: IImageEditorFirm) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        ImageEditorFirmsApi.saveImageEditorFirm(imageEditorFirm).then(
            (result: IImageEditorFirm) => {
                dispatch(saveImageEditorFirmSuccess(result));
            }
        );
}

function getImageEditorFirmSuccess(imageEditorFirm: IImageEditorFirm) {
    return {
        type: ActionTypes.GET_IMAGE_EDITOR_FIRM_SUCCESS,
        result: imageEditorFirm
    };
}

export function getImageEditorFirm(id: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        ImageEditorFirmsApi.getImageEditorFirm(id).then((result: IImageEditorFirm) => {
            dispatch(getImageEditorFirmSuccess(result));
        });
}

function updateImageEditorFirmSuccess(imageEditorFirm: IImageEditorFirm) {
    return {
        type: ActionTypes.UPDATE_IMAGE_EDITOR_FIRM_FORM_SUCCESS,
        result: imageEditorFirm
    };
}

export function updateImageEditorFirm(imageEditorFirm: IImageEditorFirm) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        ImageEditorFirmsApi.updateImageEditorFirm(imageEditorFirm).then(
            (result: IImageEditorFirm) => {
                dispatch(updateImageEditorFirmSuccess(result));
            }
        );
}

function changeIsDiscontinuedSuccess(result: number) {
    return { type: ActionTypes.CHANGE_ISDISCONTINUED_IMAGE_EDITOR_FIRM_SUCCESS, result: result };
}

export function deleteImageEditorFirm(id: number, isDiscontinued: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        ImageEditorFirmsApi.ChangeIsDiscontinuedDiscontinued(id, isDiscontinued).then(
            (result: any) => {
                dispatch(changeIsDiscontinuedSuccess(id));
            }
        );
}
